import { useMutation } from '@tanstack/react-query';

import { createPersonalPinApi } from '../api';

export default function useCreatePersonalPinMutation(config?: any) {
  return useMutation(createPersonalPinApi, config);
}
